import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiFilm, FiMail, FiGithub, FiTwitter } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: 'Legal',
      links: [
        { name: 'Terms of Service', href: '/terms' },
        { name: 'Privacy Policy', href: '/privacy' },
      ]
    },
    {
      title: 'Support',
      links: [
        { name: 'Contact Us', href: '/contact' },
        { name: 'Beta Feedback', href: '/contact?type=feedback' },
      ]
    },
  ];

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container-responsive py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img
                src="https://tfytnerazzrxlbxuvtmg.supabase.co/storage/v1/object/public/assets/nupitch_logo_ol-Centered_001-emails.png"
                alt="NuPitch Logo"
                className="h-8 w-auto"
              />
              <span className="text-xl font-bold text-white">
                <span className="font-extrabold">NuPitch</span>
                <span className="text-gray-300 ml-1">Incentive Match Maker</span>
              </span>
            </Link>
            <p className="text-gray-400 mb-4 max-w-md">
              Instantly match your film projects to global tax incentives. 
              Upload a script or paste your idea to get ranked, actionable 
              incentives in seconds.
            </p>
            <div className="flex space-x-4">
              <a
                href="mailto:info@nupitchtechnologies.com?subject=NuPitch Incentive Match Maker Support"
                className="text-gray-400 hover:text-white transition-colors focus-ring rounded-lg p-1"
                aria-label="Email"
              >
                <SafeIcon icon={FiMail} className="w-5 h-5" />
              </a>
              <a
                href="https://twitter.com/nupitchtech"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors focus-ring rounded-lg p-1"
                aria-label="Twitter"
              >
                <SafeIcon icon={FiTwitter} className="w-5 h-5" />
              </a>
              <a
                href="https://github.com/nupitchtech"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors focus-ring rounded-lg p-1"
                aria-label="GitHub"
              >
                <SafeIcon icon={FiGithub} className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h3 className="text-white font-semibold mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-gray-400 hover:text-white transition-colors focus-ring rounded px-1 py-0.5"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} NuPitch Technologies. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mt-2 sm:mt-0">
            Data source: Global Incentives Index 2025 (World of Locations / Olsberg•SPI)
          </p>
        </div>

        <div className="mt-4 text-xs text-gray-500">
          <p className="mb-2">
            <strong>BETA Notice:</strong> This is a beta version. Estimates are indicative; 
            always confirm details directly with the commission.
          </p>
          <p>
            Data correct to April 11, 2025; includes national/state/province incentives 
            with types, rates, caps, deadlines, eligibility, and sunset dates.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;